<template>
    <div>
        <div class="flex left small"><span class="f5">{{molang('dpp.propertyMortgage.poweredBy')}}</span>  <img height="12px" loading="lazy" :src="glb.cdnUrl + 'vimages/bankrate.svg'" alt="bankrate"></div>
        <div class="f8">
            Bankrate, LLC <b>NMLS #1427381</b>
            <span class="text-gray">|</span>
            BR Tech Services, Inc. <b>NMLS #1743443</b>
        </div>
        <div class="f8">
            <a class="link bottom" href="javascript:;" rel="nofollow" v-tip :tip="molang('dpp.propertyMortgage.advertiserDisclosureTip')">{{molang('dpp.propertyMortgage.advertiserDisclosure')}}</a>
            <span class="text-gray">|</span>
            <a class="link" href="https://www.bankrate.com/privacy/" rel="nofollow" target="_blank">{{molang('dpp.propertyMortgage.privacyPolicy')}}</a>
            <span class="text-gray">|</span>
            <a class="link bottom" href="javascript:;" rel="nofollow" v-tip :tip="molang('dpp.propertyMortgage.detailsTip')">{{molang('dpp.propertyMortgage.details')}}</a>
        </div>
    </div>
</template>

<script src="./bankrate-footer.js"></script>
